module.exports = __webpack_public_path__ + "static/media/default-persona.aa66e354.jpg";